import React from "react";

export const CollectionCenterInfoWindow = ({ info }) => {
  return (
    <div className="map-popup">
      <span className="time">{info.name}</span>
      <br />
    </div>
  );
};
